export const sdkInfo = {
    host: 'npmjs.com',
    version: '11.13.0',
    name: '@kentico/kontent-delivery'
};
//# sourceMappingURL=sdk-info.generated.js.map